import React, { useEffect, useState } from "react";
import axios from "axios";
import "./MiceTravel.css";
import { Link } from "react-router-dom";


const MiceTravel = () => {

const galleryImages = [
  "/Images/tour/mice/gallery1.webp",
  "/Images/tour/mice/gallery2.png",
  "/Images/tour/mice/gallery3.webp",
  "/Images/tour/mice/gallery4.jpeg",
  "/Images/tour/mice/gallery5.jpeg",
  "/Images/tour/mice/gallery6.png",
  "/Images/tour/mice/gallery7.webp",
  "/Images/tour/mice/gallery8.webp",
  "/Images/tour/mice/gallery9.webp"
];

  const [micePackages, setMicePackages] = useState([]);
  const [showGallery, setShowGallery] = useState(false);

  /* ================= FETCH API ================= */

  useEffect(() => {
    fetchMicePackages();
  }, []);

  const fetchMicePackages = async () => {
    try {
      const res = await axios.get(
        "https://admin.new.plenaryholidays.com/api/HolidayPackages/micedestinations"
      );

      console.log("MICE API:", res.data);

      // API structure safe handling
      setMicePackages(res.data.data || res.data);

    } catch (error) {
      console.log("MICE API ERROR:", error);
    }
  };


  return (
    <section className="mice-section">
      <div className="mice-container">
        {/* LEFT CONTENT */}
        <div className="mice-content">
          <h1>MICE & Corporate Travel Solutions</h1>

          <p style={{ fontWeight: "600", color: "#033073" }}>
            Meetings • Incentives • Conferences • Exhibitions • Corporate Events
          </p>

          <p>
            <strong>Plenary Holidays</strong> is a trusted MICE and corporate travel
            management company delivering seamless, result-driven events in India
            and overseas.
          </p>

          <p>
            From strategy and planning to flawless on-ground execution, we design
            customized MICE programs aligned with your business goals, timelines,
            and budgets. Backed by strong supplier networks and experienced
            professionals, we ensure every corporate movement is smooth,
            compliant, and impactful.
          </p>

          <h3>Why Choose Plenary Holidays for MICE</h3>
          <ul>
            <li>End-to-end MICE planning & execution</li>
            <li>Dedicated corporate & group travel specialists</li>
            <li>Strong hotel, airline & venue partnerships</li>
            <li>Customized programs with transparent pricing</li>
            <li>Single point of coordination from planning to closure</li>
          </ul>

          <h3>Our MICE Services</h3>
          <ul>
            <li>
              <strong>Meetings & Conferences:</strong> Venue sourcing, delegate
              management, logistics, and technical coordination
            </li>
            <li>
              <strong>Incentive Travel Programs:</strong> High-impact incentive
              tours designed to motivate, reward, and retain talent
            </li>
            <li>
              <strong>Corporate Group Travel:</strong> Domestic & international
              group movements with complete travel management
            </li>
            <li>
              <strong>Exhibitions & Trade Shows:</strong> Travel, accommodation,
              stall coordination, and on-ground support
            </li>
            <li>
              <strong>Events, Gala Dinners & Team Building:</strong> Theme nights,
              entertainment, experiential activities, and companion programs
            </li>
            <li>
              <strong>Pre & Post Event Travel:</strong> Leisure extensions,
              sightseeing, and personalized add-ons
            </li>
          </ul>

          <h3>Who We Work With</h3>
          <ul>
            <li>Corporates & MNCs</li>
            <li>SMEs & Startups</li>
            <li>Associations & Trade Bodies</li>
            <li>Event Management Companies</li>
            <li>Overseas DMC Partners</li>
          </ul>
          <Link to="/mice-corporate-travel" >
          <div className="mice-form-button-link">
            <button >MICE & Corporate Travel Solutions</button>
          </div>
          </Link>

          <p className="contact-text">
            Planning a corporate event or incentive tour? <br />
            Speak to our MICE experts for a customized proposal. <br />
            <strong>📞 +91-9560321110</strong> &nbsp; | &nbsp;
            <strong>✉️ mice@plenaryholidays.com</strong>
          </p>
        </div>

        {/* RIGHT FORM */}

      <div className="mice-form-wrapper">

        <div className="mice-form">
          <h2>
            Share your details and a <br />
            Plenary Holidays representative <br />
            will contact you ASAP!
          </h2>

          <form>
            <label>Name:</label>
            <input type="text" />

            <label>Email Id:</label>
            <input type="email" />

            <label>Organization:</label>
            <input type="text" />

            <label>Type of Requirement:</label>
            <select>
              <option value="">Select Requirement</option>
              <option>Conference</option>
              <option>Incentive Tour</option>
              <option>Corporate Meeting</option>
              <option>Exhibition</option>
              <option>Other</option>
            </select>

            <label>Mobile No:</label>
            <input type="text" />

            <div className="checkbox">
              <label className="custom-check">
                <input type="checkbox" />
                <span className="checkmark"></span>
                <span className="check-text">
                  I request a call back from Plenary Holidays
                </span>
              </label>
            </div>

            <button type="submit">Submit</button>
          </form>
        </div>

        {/* ✅ MICE GALLERY */}
        <div className="mice-gallery">
          <h3>MICE Event Gallery</h3>

          <div className="gallery-grid">
            {galleryImages.slice(0,6).map((img,index)=>(
              <img
                key={index}
                src={img}
                alt=""
                onClick={()=>setShowGallery(true)}
              />
            ))}
          </div>

          <div className="view-gallery">
            <Link to="/mice-gallery" className="gallery-btn">
              View Full Gallery
              <span>→</span>
            </Link>
          </div>
        </div>

      </div>

      </div>

        <div className="mice-packages">
          <h2>MICE Destinations</h2>

          <div className="package-grid">
            {micePackages.length > 0 ? (
              micePackages.map((pkg) => (
                <div className="package-card" key={pkg.id}>

                  <img src={pkg.image} alt={pkg.name} />

                  <div className="package-content">
                    <h4>{pkg.name}</h4>

                    <Link to={`/package/${pkg.slug}`}>
                      <button>View Details</button>
                    </Link>
                  </div>

                </div>
              ))
            ) : (
              <p>No MICE destinations available</p>
            )}
          </div>
        </div>

          {showGallery && (
            <div className="gallery-modal">
              <div className="gallery-modal-content">

                <span
                  className="close-modal"
                  onClick={()=>setShowGallery(false)}
                >
                  ✕
                </span>

                <div className="modal-gallery-grid">
                  {galleryImages.map((img,index)=>(
                    <img key={index} src={img} alt="" />
                  ))}
                </div>

              </div>
            </div>
          )}
          
    </section>
  );
};

export default MiceTravel;